import { useEffect, useState } from 'react';

/**
 * Tiny visual indicator showing that the app is NOT running on the
 * production domain. Helps avoid confusion when comparing the dev
 * preview against the live deployment side-by-side.
 *
 * Renders nothing in production (anything ending in `tdrau.online`).
 * Renders a small amber badge fixed to the top-right corner everywhere else.
 */
export const EnvironmentBadge = () => {
  const [hostname, setHostname] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setHostname(window.location.hostname);
    }
  }, []);

  // Hide on production. Anything else (localhost, *.preview.emergentagent.com,
  // forked previews, etc.) shows the badge so it's obvious where you are.
  if (!hostname || hostname.endsWith('tdrau.online')) return null;

  return (
    <div
      data-testid="env-badge"
      title={`Testing / preview environment — ${hostname}`}
      style={{
        position: 'fixed',
        top: '0.5rem',
        right: '0.75rem',
        zIndex: 9999,
        backgroundColor: '#fef3c7',
        color: '#92400e',
        border: '1px solid #fcd34d',
        borderRadius: '0.375rem',
        padding: '0.3rem 0.6rem',
        fontSize: '0.7rem',
        fontWeight: 700,
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      🧪 Testing Mode
    </div>
  );
};
